import type { AppState } from '@store/types'

import type {
  InboxWorkspaceState,
  ProjectNotificationSettingsView,
} from './types'

const EMPTY: InboxWorkspaceState = {
  fresh: [],
  freshLoaded: false,
  earlier: [],
  earlierLoading: false,
  earlierDone: false,
  unread: 0,
}

export const selectInboxWorkspace =
  (workspace: string) =>
  (state: AppState): InboxWorkspaceState =>
    state.inbox.byWorkspace[workspace] ?? EMPTY

export const selectUnreadCount =
  (workspace: string) =>
  (state: AppState): number =>
    state.inbox.unreadByWorkspace[workspace] ?? 0

export const selectUnreadByWorkspace = (state: AppState) =>
  state.inbox.unreadByWorkspace

export const selectProjectSettings =
  (projectId: string) =>
  (state: AppState): ProjectNotificationSettingsView | null =>
    state.inbox.projectSettings[projectId] ?? null
